<div class="wrapper" *ngIf="shop">
  <main class="main">
    <div class="flex-panel-container pt-5">
      <router-outlet></router-outlet>
      <div class="order-panel-container" [ngClass]="{ hide: !(shopService.shoppingCart$ | async)?.summary.products.length }">
        <div class="panel order-panel">
          <app-order-summary></app-order-summary>
        </div>
      </div>
    </div>
  </main>
</div>
<app-footer [ngClass]="{ 'summary-offset': (shopService.shoppingCart$ | async)?.summary.reservations.length > 0 }"></app-footer>
